import { JobRequestStatus } from '@/services/api'
import { Badge } from '@/shared/components/Badge'
import type { ColorDeBadge } from '@/shared/components/Badge'

interface StatusBadgeProps {
  status: string
  className?: string
}

const statusConfig: Record<string, { label: string; color: ColorDeBadge }> = {
  [JobRequestStatus.PENDIENTE_VALIDACION_PM]: {
    label: 'Pendiente Pre-aprobación',
    color: 'amarillo'
  },
  [JobRequestStatus.PRE_APROBADA]: {
    label: 'Pre-aprobada',
    color: 'azul'
  },
  [JobRequestStatus.EN_REVISION_SALARIOS]: {
    label: 'Pendiente Aprobación Salario',
    color: 'amarillo'
  },
  [JobRequestStatus.DEVUELTA_RH]: {
    label: 'Devuelta a RH',
    color: 'naranja'
  },
  [JobRequestStatus.EN_REVISION]: {
    label: 'Pre-aprobada',
    color: 'azul'
  },
  [JobRequestStatus.DEVUELTA]: {
    label: 'Devuelta',
    color: 'naranja'
  },
  [JobRequestStatus.APROBADA]: {
    label: 'Vacante Activa',
    color: 'verde'
  },
  [JobRequestStatus.RECHAZADA]: {
    label: 'Rechazada',
    color: 'rojo'
  }
}

export const StatusBadge = ({ status, className = '' }: StatusBadgeProps) => {
  const config = statusConfig[status]

  if (!config) {
    return (
      <Badge color="gris" className={className}>
        {status || 'Sin estado'}
      </Badge>
    )
  }

  return (
    <Badge color={config.color} className={className}>
      {config.label}
    </Badge>
  )
}
